// components/VoteSection.tsx
import React, { useContext, useEffect, useState } from "react";
import {
  BottomVoteBar,
  VoteButtonsContainer,
  CircleButton,
  ProgressBarContainer,
  ProgressBarWrapper,
  ProgressBarFill,
  VoteLabelsContainer,
  VoteLabel,
  VotePercentage,
  AfterVoteShowPercentage,
  VoteSVI,
} from "./ScrollVote.styles"; // adjust import path
import VoteEndPopup from "Components/PopupModal/VoteEndPopup";
import UserContext from "Contexts/User";
import AppContext from "Contexts/AppContext";
import VoteAndPower from "./VoteAndPower";
import useSound from "use-sound";
// @ts-ignore
import buttonClick from "../../assets/sounds/mail-sent.mp3";
import { getSVIData } from "common/utils/helper";

type Props = {
  item: any;
  onVote: (id: string, v: "up" | "down") => void;
  isLoading?: boolean;
  voteID?: string;
};

const VoteSection: React.FC<Props> = ({ item, onVote, isLoading = false, voteID }) => {
  // Derive percentages from counts if provided: { up, down, total }
  const { userInfo } = useContext(UserContext);
  const [voteNumber, setVoteNumber] = useState(0);
  const [SVIdetelis, setSVIdetelis] = useState<any>({})
  const { setLogin, setLoginRedirectMessage } = useContext(AppContext);
  const [handleSoundClick] = useSound(buttonClick, { interrupt: true, html5: true });

  const {
    afterVotePopup,
    setAfterVotePopup,
  } = useContext(AppContext);
  // Determine counts (item.vote or item itself)
  useEffect(() => {
    // Only subscribe if we have a valid voteID
    if (userInfo?.uid === "") {
      return;
    }
    if (!voteID || voteID === "") {
      return;
    }
    const unsubscribe = getSVIData(voteID, setSVIdetelis);
    return () => {
      console.log('🔕 Cleaning up listener for vote:', voteID);
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [voteID]); // Re-run when voteID changes

  const countsSource = SVIdetelis && typeof SVIdetelis.votes === "object" ? SVIdetelis.votes : item?.vote;
  const up = typeof countsSource?.up === "number" ? countsSource.up : 0;
  const down = typeof countsSource?.down === "number" ? countsSource.down : 0;
  const total = (typeof countsSource?.total === "number")
    ? countsSource.total
    : up + down;
  // Baseline: show 50/50 when no votes.
  // We add the real votes to the baseline so the first vote becomes visible (51/49).
  const BASE_EACH = 50;   // baseline votes for each side
  const BASE_TOTAL = BASE_EACH * 2; // 100

  let leftPct = 50;
  if (total > 0) {
    // floating percentage before integer rounding
    const leftFloat = ((BASE_EACH + up) / (BASE_TOTAL + total)) * 100;

    // If one side leads, bias rounding so leader gets the extra percent on ties-from-rounding.
    if (up > down) {
      leftPct = Math.ceil(leftFloat);
    } else if (up < down) {
      leftPct = Math.floor(leftFloat);
    } else {
      // exact tie in counts -> round normally
      leftPct = Math.round(leftFloat);
    }
  } else {
    // total === 0 -> show exact 50/50
    leftPct = 50;
  }

  const rightPct = 100 - leftPct;

  useEffect(() => {
    setVoteNumber(
      Number(userInfo?.voteValue || 0) +
      Number(userInfo?.rewardStatistics?.extraVote || 0)
    );
  }, [userInfo?.voteValue, userInfo?.rewardStatistics?.extraVote])

  const handleVote = (v: "up" | "down") => {
    if (!userInfo?.uid) {
      setLoginRedirectMessage("cast your vote");
      setLogin(true);
    }
    else if (voteNumber > 0) {
      onVote(item.id, v)
      handleSoundClick()
    } else {
      setAfterVotePopup(true)
    }
  }


  return (
    <BottomVoteBar>
      {/* {item?.voted == false ? (
        <VoteButtonsContainer>          
          <CircleButton
            disabled={isLoading}
            $compactText={(() => {
              const t = (item?.thumbs_meaning?.up || "Yes").toString();
              return t.trim().split(/\s+/).filter(Boolean).length > 5;
            })()}
            onClick={() => {handleVote("up")}}
          >
            {item?.thumbs_meaning?.up || "Yes"}
          </CircleButton>
                    
          {userInfo?.uid && <VoteAndPower/>}

          <CircleButton
            disabled={isLoading}
            $compactText={(() => {
              const t = (item?.thumbs_meaning?.down || "No").toString();
              return t.trim().split(/\s+/).filter(Boolean).length > 5;
            })()}
            onClick={() => {handleVote("down")}}
          >
            {item?.thumbs_meaning?.down || "No"}
          </CircleButton>

        </VoteButtonsContainer>
      ) : (
        <ProgressBarContainer>
          <h2 className="text-center my-3">Members Voted</h2>
          <ProgressBarWrapper>            
            <ProgressBarFill
              className={item.animate ? "progress-bar-animated" : ""}
              $leftPercentage={leftPct}
            />
          </ProgressBarWrapper>
          <VoteLabelsContainer>
            <div>
              <VoteLabel>{item?.thumbs_meaning?.up || "Yes"}</VoteLabel>
              <VotePercentage>{leftPct}%</VotePercentage>
            </div>
            <div style={{ textAlign: "right" }}>
              <VoteLabel>{item?.thumbs_meaning?.down || "No"}</VoteLabel>
              <VotePercentage>{rightPct}%</VotePercentage>
            </div>
          </VoteLabelsContainer>
        </ProgressBarContainer>
      )} */}


      <VoteButtonsContainer>
        <CircleButton
          disabled={isLoading || item?.voted}
          $compactText={(() => {
            const t = (item?.thumbs_meaning?.up || "Yes").toString();
            return t.trim().split(/\s+/).filter(Boolean).length > 5;
          })()}
          $isVoted={item?.votedOption === "up"}
          onClick={() => {
            if (item?.voted == false) handleVote("up")
          }
          }
          style={{ cursor: item?.voted ? 'not-allowed' : 'pointer', opacity: item?.voted ? 0.7 : 1 }}
        >
          {item?.thumbs_meaning?.up || "Yes"}
        </CircleButton>

        {userInfo?.uid && <VoteAndPower disabledPower={item?.voted} customPowerValue={""} />}

        <CircleButton
          disabled={isLoading || item?.voted}
          $compactText={(() => {
            const t = (item?.thumbs_meaning?.down || "No").toString();
            return t.trim().split(/\s+/).filter(Boolean).length > 5;
          })()}
          $isVoted={item?.votedOption === "down"}
          onClick={() => {
            if (item?.voted == false) handleVote("down")
          }}
          style={{ cursor: item?.voted ? 'not-allowed' : 'pointer', opacity: item?.voted ? 0.7 : 1 }}
        >
          {item?.thumbs_meaning?.down || "No"}
        </CircleButton>


      </VoteButtonsContainer>

      {item?.voted && <AfterVoteShowPercentage>
        <VotePercentage>{leftPct}%</VotePercentage>
        <VoteSVI>SVI</VoteSVI>
        <VotePercentage>{rightPct}%</VotePercentage>
      </AfterVoteShowPercentage>}
      {afterVotePopup && <>
        <VoteEndPopup />
      </>}
    </BottomVoteBar>
  );
};

export default VoteSection;
